import React, {useEffect, useState} from 'react';
import { IntlProvider } from 'react-intl';
import { locales, DEFAULT_LOCALE } from 'common/constants/i18n';
import { createIntl, createIntlCache } from 'react-intl';
const cache = createIntlCache();

export const IntlContext = React.createContext('intl');

const getDefaultLocale = () => {
  return DEFAULT_LOCALE;
};

const AppIntlProvider = ({ children }) => {
  const [intls, setIntls] = useState({});
  const [locale, setLocale] = useState(getDefaultLocale());

  useEffect(   () => {
    const intlsObj = {};
    locales.forEach(locale => {
      const messages = require (`./locales/${locale}.json`);
      intlsObj[locale] = createIntl({ locale, messages }, cache);
    });
    setIntls(intlsObj);
  }, []);
  
  const changeLocale = newLocale => {
    setLocale(newLocale);
  };
  
  if(Object.keys(intls).length === locales.length) {
    return(
      <IntlContext.Provider value={{ changeLocale, intls, locale }}>
        <IntlProvider locale={locale}>
          { children }
        </IntlProvider>
      </IntlContext.Provider>
    );
  } else {
    return null;
  }
  
};

const useTranslation = () => {
  const context = React.useContext(IntlContext);
  if (context === undefined) {
    throw new Error('IntlContext must be used within a AppIntlProvider');
  }
  return context;
};

export { AppIntlProvider, useTranslation };